import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axios";

export const fetchDivisionData = createAsyncThunk(
    "selectedDivision/fetchDivisionData",
    (division_code, thunkAPI) => {
        if (!division_code) {
            const state = thunkAPI.getState();
            division_code = state.selectedDivision.divisionData?.division_code;
            if (!division_code) {
                return thunkAPI.rejectWithValue(
                    "No division number provided and none found in state."
                );
            }
        }

        return axiosInstance
            .get(`/divisions/${division_code}`)
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                // Construct an error object with message and code
                let errorMessage = "An error occurred";
                let errorCode = "Unknown";

                if (error.response) {
                    // Axios error response structure
                    errorMessage = error.response.data.message || error.message;
                    errorCode = error.response.status;
                } else if (error.request) {
                    // Request was made but no response received
                    errorMessage = "No response received";
                } else {
                    // Error setting up the request
                    errorMessage = error.message;
                }

                return thunkAPI.rejectWithValue({
                    message: errorMessage,
                    code: errorCode,
                });
            });
    }
);

const selectedDivisionSlice = createSlice({
    name: "selectedDivision",
    initialState: {
        divisionData: null,
        status: "idle",
        error: null,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchDivisionData.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(fetchDivisionData.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.divisionData = action.payload;
                state.error = null
            })
            .addCase(fetchDivisionData.rejected, (state, action) => {
                state.status = "failed";

                state.error = {
                    message: 
                        action.payload?.message ||
                        action.error.message ||
                        "An error occurred",
                    code: action.payload?.code || "Unknown",
                };
            });
    },
});

export default selectedDivisionSlice.reducer;